import React from "react";
import LegalPage from "../components/LegalPage";
import { termsConditions } from "../data/legal";

export default function TermsConditions() {
  return <LegalPage doc={termsConditions} />;
}
